import { IS_NATIVE } from '~/utils/platform'

/** Finish the native version check before Firebase's boot policy is installed. */
export default defineNuxtPlugin({
  name: 'native-client-config',
  enforce: 'pre',
  async setup() {
    if (!IS_NATIVE) return
    const update = useNativeUpdate()
    window.addEventListener('elemental-dispatch-update-required', (event) => {
      const version = (event as CustomEvent<{ minVersion?: string }>).detail?.minVersion
      // A 426 remains blocking even if a proxy omitted its JSON body.
      update.floor.value = typeof version === 'string' && /^v\d+\.\d+$/.test(version) ? version : 'required'
    })
    await update.retry()
  },
})
